import { render, staticRenderFns } from "./ownerManager.vue?vue&type=template&id=bd306f4e&scoped=true&"
import script from "./ownerManager.vue?vue&type=script&lang=js&"
export * from "./ownerManager.vue?vue&type=script&lang=js&"
import style0 from "./ownerManager.vue?vue&type=style&index=0&id=bd306f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd306f4e",
  null
  
)

export default component.exports